import { FormPage } from '@checkit/react-components';
import { EditIcon } from '@checkit/react-components/build/components/Icons';
import { CircularProgress, Grid } from '@material-ui/core';
import React, { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { AnyAction } from 'redux';

import { useAxiosDispatch } from '../../middleware/axios';
import { createSnackbar } from '../../notifications/actions';
import { State } from '../../state';
import { getCheckpoint, isUpdateCheckpointSuccess, updateCheckpoint } from '../actions';
import { messages as messagesCommon } from '../common.translations';
import CheckpointForm from '../components/form/CheckpointForm';
import { Checkpoint, CheckpointDto } from '../state';

import { messages } from './UpdateCheckpoint.translations';

export interface Props extends RouteComponentProps<{checkpointCode: string}> {
  checkpoint?: Checkpoint | null;
}

const UpdateCheckpoint: FC<Props> = (props: Props) => {
  const { match, history, checkpoint } = props;
  const { formatMessage } = useIntl();
  const dispatch = useAxiosDispatch( );

  const code = match.params.checkpointCode;

  useEffect(() => {
    dispatch(getCheckpoint(code));
  }, [dispatch, code]);

  const onSubmit = async (data: CheckpointDto): Promise<AnyAction> => {
    const action = await dispatch(updateCheckpoint(code, data, history));

    if (isUpdateCheckpointSuccess(action)) {
      dispatch(createSnackbar({
        message: formatMessage(messages['checkpoint.update.success']),
        options: {
          variant: 'success'
        }
      }));
    } else {
      const errorType = action.error ? (action as any).error.response.data.message : null;
      if (errorType === messagesCommon.CHECKPOINT_NAME_NOT_UNIQUE.id) {
        dispatch(createSnackbar({
          message: formatMessage(messagesCommon.CHECKPOINT_NAME_NOT_UNIQUE),
          options: {
            autoHideDuration: 5000,
            variant: 'error'
          }
        }));
      } else if (errorType === messagesCommon.QR_CODE_NOT_UNIQUE.id) {
        dispatch(createSnackbar({
          message: formatMessage(messagesCommon.QR_CODE_NOT_UNIQUE),
          options: {
            autoHideDuration: 5000,
            variant: 'error'
          }
        }));
      } else {
        dispatch(createSnackbar({
          message: formatMessage(messages['checkpoint.update.error']),
          options: {
            variant: 'error'
          }
        }));

      }
    }
    return action;
  };

  return (
    <FormPage
      pageTitle={formatMessage(messages['checkpoint.update.pageTitle'])}
      pageIcon={<EditIcon/>}
    >
      {
        checkpoint ?
          <CheckpointForm checkpoint={checkpoint} onSubmit={onSubmit} /> :
          <Grid container={true} justify="center"><CircularProgress color="inherit" /></Grid>
      }

    </FormPage>
  );
};

const mapStateToProps = (state: State, props: Props) => ({
  checkpoint: props.match.params.checkpointCode
    ? state.checkpoints.byCode[props.match.params.checkpointCode] : null
});
export default connect(mapStateToProps)(UpdateCheckpoint);
